const styles = `:host {
  border-bottom: 1px solid var(--goto-border-color-default);
  display: table-row;
  height: var(--goto-datatable-row-height, 56px);
}

:host([selected]) {
  background-color: var(--goto-interactive-color-secondary-hover);
}

:host([disabled]) {
  --goto-datatable-cell-color: var(--goto-type-color-disabled);
  background-color: var(--goto-interactive-color-disabled);
}`; export default styles;